import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IBatchActivity } from "@common/interfaces/batchActivity";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface BatchActivityState extends EntityState<IBatchActivity, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.GLOBAL_BATCH_ACTIVITIES })
export class GlobalBatchActivityStore extends EntityStore<BatchActivityState> {
    constructor() {
        super([]);
    }
}

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.PROJECT_BATCH_ACTIVITIES })
export class ProjectBatchActivityStore extends EntityStore<BatchActivityState> {
    constructor() {
        super([]);
    }
}


@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.USER_BATCH_ACTIVITIES })
export class UserBatchActivityStore extends EntityStore<BatchActivityState> {
  constructor() {
      super([]);
  }
}
